module.exports = __webpack_public_path__ + "img/smile.ec5720c7.svg";